module.exports = __webpack_public_path__ + "img/6_1.9c06bfa9.png";